'use es6';

import { hasSufficientReportCreatePermission } from '../../../lib/report-logic';
import { hasSufficientDashboardCreatePermission } from '../../../lib/dashboardLogic';
import { useIsUserEmailOwner } from '../../../permissions/hooks/useIsUserEmailOwner';
import { INSUFFICIENT_ASSET_PERMISSION_LEVEL } from '../../problems';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const useEditRecurringEmailProblem = ({
  report,
  dashboard,
  schedule
}) => {
  const {
    data: isUserEmailOwnerData,
    error: isUserEmailOwnerError
  } = useIsUserEmailOwner({
    schedule
  });
  const isUserEmailOwner = isUserEmailOwnerError ? false : isUserEmailOwnerData;
  const userHasSufficientCreatePermission = dashboard ? hasSufficientDashboardCreatePermission(dashboard) : hasSufficientReportCreatePermission(report);
  if (!isUserEmailOwner && !userHasSufficientCreatePermission) {
    return {
      problem: INSUFFICIENT_ASSET_PERMISSION_LEVEL,
      disabledMessage: dashboard ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.tooltip.needCreateDashboard"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.tooltip.needCreateReport"
      })
    };
  }
  return {
    problem: null,
    disabledMessage: null
  };
};
export default useEditRecurringEmailProblem;